import styled, { css } from 'styled-components'

export const PaginationContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  gap: 12px;

  button {
    background-color: ${({ theme }) => `rgb(${theme.background.low})`};

    border: 1px solid #055175;
    border-radius: 5px;
    background-color: transparent;
    width: 47px;
    height: 58.39px;

    font-size: 14px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .aleatory {
      width: 20px;
      height: 15px;
    }

    .unanswered {
      width: 20px;
      height: 10px;
    }

    .tooltip {
      display: none;
    }

    @media only screen and (min-width: 800px) {
      width: 60px;
      height: 60px;

      .tooltip {
        position: relative;
        display: inline-block;
      }

      .tooltip .tooltiptext {
        visibility: hidden;
        background-color: #222222;
        color: white;
        text-align: center;
        border-radius: 4px;
        padding-top: 5px;
        width: auto;
        height: auto;
        white-space: nowrap;
        padding: 7px;
        position: absolute;
        z-index: 1;
        top: 53px;
        left: 5px;
        opacity: 0;
        margin-left: -75px;
        transition: opacity 0.3s;
      }

      :hover .tooltiptext {
        visibility: visible;
        opacity: 1;

        ::after {
          content: '';
          border-style: solid;
          border-width: 6px;
          border-color: transparent transparent #2c2c2c;
          position: absolute;
          top: 13px;
          left: 80px;
          margin-top: -25px;
        }
      }
    }
  }
`

export const FloatingArrow = styled.div`
  @media only screen and (min-width: 800px) {
    position: absolute;
    top: 157%;
    left: 40%;
    transform: translateX(-50%);
    background-color: #000;
    color: #fff;
    padding: 5px;
    border-radius: 5px;

    ::after {
      content: '';
      border-style: solid;
      border-width: 6px;
      border-color: transparent transparent #2c2c2c;
      position: absolute;
      top: 30%;
      left: 77%;
      margin-top: -25px;
    }
  }

  /* position: absolute;
  top: 60px;
  left: 93%;

  color: #f9f9f9;
  font-size: 0.75rem;
  font-weight: 500;
  background: #2c2c2c;
  border-radius: 4px;
  padding: 12px 13px;
  opacity: 0;
  pointer-events: none;

  transition: opacity 0.3s ease;
  z-index: 20;
  width: max-content;

  ::after {
    content: '';
    border-style: solid;
    border-width: 6px;
    border-color: transparent transparent #2c2c2c;
    position: absolute;
    top: 35%;
    left: 77%;
    margin-top: -25px;
  }

  @media only screen and (max-width: 400px) {
    position: absolute;
    left: 0%;

    ::after {
      left: 90%;
    }
  } */
`
